export default "__VITE_ASSET__B_Zm11OL__"